import GeneralPopup from '../shared/GeneralPopup';
import React, { useState, forwardRef, useImperativeHandle } from "react";
import { auth } from '../services/auth';
import Loader from '../shared/Loader';
import { transaction } from '../services/transaction';
import styles from '../css/transaction.module.css'

const AddTransaction = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({
        togglePopupTrans(value) {
            setPopupTrans(!showPopupTrans);
        }
    }));

    const { refresh } = props;
    const [showPopupTrans, setPopupTrans] = useState(false);

    const user = auth().getUser();
    const token = auth().getToken();
    const [errors, setErrors] = useState({
        amount: true,
        payment_paymentComment: true
    });
    const [hasError, setHasError] = useState(false);
    const [error, setError] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };
    const validateFields = (amount, paymentComment) => {
        // true means invalid, so our conditions got reversed
        setErrors({
            amount: amount?.length > 0 || inputs?.amount > 0,
            //payment_paymentComment: paymentComment?.length > 0,
        })
    }
    const product = {
        description: null,
        amount: 0,
        payment: {
            paymentComment: null
        },
        firstName: user?.firstName,
        lastName: user?.lastName,
        email: user?.email
    };

    const [inputs, setInputs] = useState(product);

    const handleChange = (event) => {
        const name = event.target.name;
        let value = event.target.value;
        if (event.target.type === "checkbox") {
            if (event.target.checked) {
                value = true;
            } else {
                value = false;
            }
        }

        if (event.target.type === "number") {
            value = parseFloat(event.target.value);
        }
        let val;

        if (name.includes("_")) {
            const objectArray = name.split("_");
            val = { ...inputs, [objectArray[0]]: { [objectArray[1]]: value } };
        } else {
            val = { ...inputs, [name]: value };
        }

        setInputs(val);
    }

    //Used for nested objects name must be in format parent_child. (only one level)

    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsLoading(true);
        if (!inputs?.amount?.toString().length > 0 || !inputs?.amount > 0) {
            validateFields(inputs?.amount, inputs?.payment?.paymentComment)
            setIsLoading(true);
            return null;
        }

        return transaction(user, inputs, config)
            .then((response) => {
                togglePopupTrans();
                refresh();
                setInputs(product);
                window.location.replace(response.data.paymentUrl);
                return response.data;
            }).catch((error) => {
                setHasError(true);
                setError("Invalid adding funds, please try again");
            })
            .finally(() => {
                setIsLoading(false);
            });
    }

    const togglePopupTrans = (value) => {
        setPopupTrans(!showPopupTrans);
    }

    return (
        <div>
            {showPopupTrans ? (
                <GeneralPopup title='Add Transaction' closePopup={togglePopupTrans} >
                    <div className=''>
                        <div className='flex flex-col md:flex-col lg:flex-row justify-center align-center lg:mt-10 lg:justify-around'>
                            <div className='flex flex-col items-center'>
                                <div className=''>
                                    <p>
                                        <label className="uppercase font-semibold" htmlFor="amount">Amount to add</label>
                                    </p>
                                    <input className={`${styles.transactionInput} ${!errors?.amount ? " border-3 border-rose-600" : "border-b-gray-600"}`} onChange={handleChange} type="number" value={inputs?.amount} name="amount" id="amount" required />
                                    {!errors?.amount ? (
                                        <p className="text-red-600">This field is required!</p>
                                    ) : null}
                                </div>
                                {/* <div className=''>
                                    <p>
                                        <label className="uppercase font-semibold" htmlFor="payment_paymentComment">Comment</label>
                                    </p>
                                    <input className={`${styles.transactionInput} ${!errors?.payment_paymentComment ? " border-3 border-rose-600" : "border-b-gray-600"}`} onChange={handleChange} type="text" value={inputs?.payment.paymentComment || ""} name="payment_paymentComment" id="payment_paymentComment" required />
                                    {!errors?.payment_paymentComment ? (
                                        <p className="text-red-600">This field is required!</p>
                                    ) : null}
                                </div> */}
                            </div>
                            <div className='flex flex-col items-center self-center'>
                                <button onClick={handleSubmit} className="my-5 px-20 py-3 w-80 self-start uppercase rounded-3xl text-white bg-pink-350 shadow-xl hover:opacity-90 transition-all">Add Amount</button>
                            </div>
                            {isLoading ?
                                (<div className="my-5 mx-20 flex flex-row justify-center"> <Loader styles={"w-12 h-12"}></Loader> </div>) :
                                hasError ? ((<p className="my-10 text-xl text-red-600">Failed loading, please try again!</p>)) : null}
                        </div>
                    </div>
                </GeneralPopup>) : null}
        </div>
    )
});
export default AddTransaction;